module.exports = __webpack_public_path__ + "img/user-09.0309b6a2.jpg";